import { useMemo, JSX } from 'react'

import escapeRegExp from 'lodash/escapeRegExp'
import uniq from 'lodash/uniq'
interface AnnotatedTextHookProps<T extends keyof JSX.IntrinsicElements = 'u'> {
    text: string
    query: string | null
    highlightQuery?: boolean
    tagName?: T
}

export function useAnnotatedText<T extends keyof JSX.IntrinsicElements = 'u'>({
    text,
    query,
    highlightQuery = true,
    tagName = 'u' as T,
}: AnnotatedTextHookProps<T>): string {
    return useMemo(
        () =>
            highlightQuery && query
                ? uniq(
                      text.match(new RegExp(escapeRegExp(query), 'gi')) || []
                  ).reduce(
                      (res, match) =>
                          res.replace(
                              new RegExp(escapeRegExp(match), 'g'),
                              `<${tagName}>${match}</${tagName}>`
                          ),
                      text
                  )
                : text,
        [highlightQuery, query, text, tagName]
    )
}
